import { Button } from '@material-tailwind/react'
import React from 'react'

const Dimensions = ({ dimension, setDimension, dimentionData, setDimentionData, handleDimensionData }) => {
  const dimensionFields = [
    { key: 'name', label: 'Description', type: 'text', placeholder: 'Carton description', className: 'md:col-span-2 xl:col-span-2' },
    { key: 'qty', label: 'Qty', type: 'number', placeholder: '0', className: 'xl:col-span-1' },
    { key: 'width', label: 'Width (cm)', type: 'number', placeholder: '0', className: 'xl:col-span-1' },
    { key: 'height', label: 'Height (cm)', type: 'number', placeholder: '0', className: 'xl:col-span-1' },
    { key: 'length', label: 'Length (cm)', type: 'number', placeholder: '0', className: 'xl:col-span-1' },
  ];

  const removeDimesion = (width) => {
    const index = dimension.findIndex((item) => item.width === width);
    if (index !== -1) {
      const newVariations = [...dimension];
      newVariations.splice(index, 1);
      setDimension(newVariations);
    }
  };

  return (
    <div className='rounded-[28px] border border-slate-200 bg-white px-5 py-5 shadow-[0_18px_42px_rgba(15,23,42,0.07)] lg:px-6'>
      <div className='mb-6 flex flex-col gap-1 border-b border-slate-100 pb-5'>
        <div className='flex items-center gap-3'>
          <div className='flex h-10 w-10 items-center justify-center rounded-2xl bg-[#fff1e8] text-sm font-[GilroyBold] text-[#ea580c]'>02</div>
          <div>
            <h3 className='font-[GilroyBold] text-[1.15rem] text-slate-900'>Package dimensions</h3>
            <p className='text-sm font-[GilroyMedium] text-slate-500'>Add cartons or package blocks for the shipment.</p>
          </div>
        </div>
      </div>

      <div>
        <div className='rounded-[24px] border border-slate-200 bg-slate-50/70 p-4 md:p-5'>
          <div className='mb-4'>
            <h4 className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Add carton block</h4>
            <p className='mt-1 text-sm text-slate-500'>Enter each distinct package size once, then keep stacking additional rows below.</p>
          </div>
          <div className='grid gap-4 md:grid-cols-2 xl:grid-cols-6'>
            {dimensionFields.map((field) => (
              <label key={field.key} className={`block ${field.className}`}>
                <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>
                  {field.label}
                </span>
                <input
                  type={field.type}
                  value={dimentionData[field.key] || ''}
                  onChange={(e) => setDimentionData({ ...dimentionData, [field.key]: e.target.value })}
                  required
                  placeholder={field.placeholder}
                  className='h-14 w-full rounded-[18px] border border-slate-300 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 outline-none transition focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'
                />
              </label>
            ))}
          </div>
          <div className='mt-4 flex justify-end'>
            <Button onClick={handleDimensionData} className='rounded-full bg-[#f97316] px-5 py-2.5 text-xs font-[GilroyBold] text-white shadow-[0_12px_24px_rgba(249,115,22,0.22)] hover:bg-[#ea580c]'>Add Dimension</Button>
          </div>
        </div>

        <div className='mt-5 overflow-hidden rounded-[22px] border border-slate-200'>
          <div className='grid grid-cols-5 bg-[#fffaf6] px-4 py-3 text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>
            <p>Qty</p>
            <p>Width</p>
            <p>Height</p>
            <p>Length</p>
            <p>Actions</p>
          </div>
          {dimension?.length ? dimension.map((item, index) => (
            <div key={`${item.width}-${item.height}-${item.length}-${index}`} className='grid grid-cols-5 border-t border-slate-100 bg-white px-4 py-3 text-[13px] font-[GilroyMedium] text-slate-700'>
              <p>{item.count}</p>
              <p>{item.width} cm</p>
              <p>{item.height} cm</p>
              <p>{item.length} cm</p>
              <button type='button' onClick={() => removeDimesion(item.width)} className='w-fit font-[GilroyBold] text-red-500'>Remove</button>
            </div>
          )) : (
            <div className='px-4 py-10 text-center text-sm font-[GilroyMedium] text-slate-400'>No dimensions added yet.</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Dimensions
